import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/Navbar/Navbar.jsx';
import Footer from './components/Footer/Footer.jsx';
import './App.css';

// Lazy load — yeh sabse bada performance fix hai
const Homepage = lazy(() => import('./pages/Homepage/Homepage.jsx'));
const Services = lazy(() => import('./pages/Services/Services.jsx'));
const Portfolio = lazy(() => import('./pages/Portfolio/Portfolio.jsx'));
const About = lazy(() => import('./pages/About/Aboutus.jsx'));
const Career = lazy(() => import('./pages/Career/Career.jsx'));
const Contact = lazy(() => import('./pages/Contact/Contact.jsx'));
const PrivacyPolicy = lazy(() => import('./pages/Legal/Privacypolicy.jsx'));
const TermsOfService = lazy(() => import('./pages/Legal/Termsofservice.jsx'));
const RulesRegulation = lazy(() => import('./pages/Career/rules&regulation.jsx'));
const Webdevelopmentform = lazy(() => import('./pages/Career/Web_Development/Webdevelopmentform.jsx'));
const Socialmediamarketingform = lazy(() => import('./pages/Career/Social_Media_Marketing/Socialmediamarketingform.jsx'));

const SECTION_PATHS = ['/services', '/portfolio', '/about', '/career', '/contact'];

function MainLayout() {
  useEffect(() => {
    const sections = [
      { id: 'home',      title: 'Opramix',                hash: '/' },
      { id: 'services',  title: 'Services | Opramix',     hash: '/services' },
      { id: 'portfolio', title: 'Portfolio | Opramix',    hash: '/portfolio' },
      { id: 'about',     title: 'About Us | Opramix',     hash: '/about' },
      { id: 'career',    title: 'Career | Opramix',       hash: '/career' },
      { id: 'contact',   title: 'Contact | Opramix',      hash: '/contact' },
    ];

    // Force title on mount
    document.title = 'Opramix';

    const updateHash = () => {
      const path = window.location.pathname;
      if (!SECTION_PATHS.includes(path) && path !== '/') return;
      const viewportMiddle = window.scrollY + window.innerHeight / 2;
      let current = sections[0];
      for (const section of sections) {
        const el = document.getElementById(section.id);
        if (el && el.offsetTop <= viewportMiddle) current = section;
      }
      if (window.location.pathname !== current.hash) {
        document.title = current.title;
        window.history.replaceState(null, current.title, current.hash);
      }
    };

    updateHash();
    window.addEventListener('scroll', updateHash, { passive: true });
    return () => window.removeEventListener('scroll', updateHash);
  }, []);

  return (
    <div className="App">
      <Navbar />
      <div className="main-content">
        <Suspense fallback={<div style={{minHeight:'100vh'}}/>}>
          <Homepage />
          <Services />
          <Portfolio />
          <About />
          <Career />
          <Contact />
        </Suspense>
      </div>
      <Footer />
    </div>
  );
}

function WebDevFormPage() {
  const navigate = useNavigate();
  return (
    <Suspense fallback={<div style={{minHeight:'100vh'}}/>}>
      <Webdevelopmentform onClose={() => navigate(-1)} />
    </Suspense>
  );
}

function SocialMediaFormPage() {
  const navigate = useNavigate();
  return (
    <Suspense fallback={<div style={{minHeight:'100vh'}}/>}>
      <Socialmediamarketingform onClose={() => navigate(-1)} />
    </Suspense>
  );
}

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Suspense fallback={<div style={{minHeight:'100vh'}}/>}>
          <Routes>
            <Route path="/" element={<MainLayout />} />
            <Route path="/services" element={<MainLayout />} />
            <Route path="/portfolio" element={<MainLayout />} />
            <Route path="/about" element={<MainLayout />} />
            <Route path="/career" element={<MainLayout />} />
            <Route path="/contact" element={<MainLayout />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/career/rules-regulations" element={<RulesRegulation />} />
            <Route path="/career/web-development-internship-form" element={<WebDevFormPage />} />
            <Route path="/career/social-media-internship-form" element={<SocialMediaFormPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
